import {ACTION_CODE} from './_actionCode';
import {ProductionCategoryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_PRODUCTIONCATEGORY';

export async function updateProductionCategory(
    userData: Record<string, any>,
    productionCategoryId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateProductionCategoryById - Start');

        const updateProductionCategoryByIdResult =
            await ProductionCategoryService.updateProductionCategory(userData, productionCategoryId, payloadUpdate);

        LoggerService.logInfo('Action - updateProductionCategoryById - End - Success');

        return ResultModel.newSuccessResult(updateProductionCategoryByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateProductionCategoryById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
